import { render, staticRenderFns } from "./SharedContentPage.vue?vue&type=template&id=a42ef208&scoped=true"
import script from "./SharedContentPage.vue?vue&type=script&lang=ts"
export * from "./SharedContentPage.vue?vue&type=script&lang=ts"
import style0 from "./SharedContentPage.vue?vue&type=style&index=0&id=a42ef208&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a42ef208",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/nola-frontend/nola-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a42ef208')) {
      api.createRecord('a42ef208', component.options)
    } else {
      api.reload('a42ef208', component.options)
    }
    module.hot.accept("./SharedContentPage.vue?vue&type=template&id=a42ef208&scoped=true", function () {
      api.rerender('a42ef208', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/novel/SharedContentPage.vue"
export default component.exports